import 'material-design-icons-iconfont/dist/material-design-icons.css' // Ensure you are using css-loader

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import axios from 'axios';

import './actioninterface.js';

Vue.config.productionTip = false

Vue.use(vuetify,{
  iconfont: 'md'
})

Vue.prototype.$eventHub = new Vue();

new Vue({
  vuetify,
  router,
  render: h => h(App),
  data() {
    return {
      tripSiteId:null,
      themeColor:null,
      tripTitle:null,
      downloadStatus:null,
      baseUrl: process.env.NODE_ENV === 'production' ? 'https://platinumclubandgoldclub.azurewebsites.net' : 'https://platinumclubandgoldclub.azurewebsites.net',
      platform:null,
      tripInfo: {},
      PdfHeader: null,
    }
  },
  methods:{
    fn_enterTrip: function(tripId){
      let self = this;
      let pcgcTripId = tripId.toString();
      this.getData('SwitchTrip', pcgcTripId, 
        {
          onSuccess: function(response){
              console.log(response);
              self.fn_setTheme(tripId);
          },
          onError: function(error){
              console.log(error);
              self.$root.fn_showToast("exception");
          }
      });
    },

    fn_setTheme: function(tripId){
      this.tripSiteId = tripId;
      if(tripId == 7){
          this.themeColor = "#395b83";
          this.tripTitle = "Platinum Club"
      }
      else if(tripId == 8){
          this.themeColor = "#d64227";
          this.tripTitle = "AMERICAS GOLD CLUB"
      }
      else if(tripId == 9){
          this.themeColor = "#004987";
          this.tripTitle = "ASIA GOLD CLUB"
      }
      else if(tripId == 10){
        this.themeColor = "#0093c9";
        this.tripTitle = "EMEA GOLD CLUB"
      }
      else if(tripId == 11){
          this.themeColor = "#004987";
          this.tripTitle = "Phuket Club Trip"
      }
      else if(tripId == 17){
        this.themeColor = "#003765";
        this.tripTitle = "AMERICAS GOLD CLUB"
      }
      else if(tripId == 18){
        this.themeColor = "#005474";
        this.tripTitle = "ASIA GOLD CLUB"
      }
      else if(tripId == 19){
        this.themeColor = "#201650";
        this.tripTitle = "EMEA GOLD CLUB"
      }
      else if(tripId == 20){
        this.themeColor = "#5cbfbf";
        this.tripTitle = "Platinum Club Trip"
      }
      else if(tripId == 22){
        this.themeColor = "#122854";
        this.tripTitle = "AMERICAS GOLD CLUB"
      }
      else if(tripId == 23){
        this.themeColor = "#1f1647";
        this.tripTitle = "ASIA GOLD CLUB"
      }
      else if(tripId == 24){
        this.themeColor = "#1e2152";
        this.tripTitle = "EMEA GOLD CLUB"
      }
      else if(tripId == 25){
        this.themeColor = "#1d3e6c";
        this.tripTitle = "Platinum Club Trip"
      }
      else if(tripId == 27){
        this.themeColor = "#243d84";
        this.tripTitle = "AMERICAS GOLD CLUB"
      }
      else if(tripId == 28){
        this.themeColor = "#003b71";
        this.tripTitle = "ASIA GOLD CLUB"
      }
      else if(tripId == 29){
        this.themeColor = "#1a1d55";
        this.tripTitle = "EMEA GOLD CLUB"
      }
      else if(tripId == 30){
        this.themeColor = "#0c5d6f";
        this.tripTitle = "Platinum Club Trip"
      }
      this.$router.replace('/homepage');
    },

    fn_showToast: function(msg){
      let message;
      if(msg === 'exception'){
        message = 'Something went wrong. Please try again'
      }
      else if(msg === 'nointernet'){
        message = 'Internet not available'
      }
      else{
        message = msg
      }
      this.getData('ShowToast', message, 
          {
              onSuccess: function(response){
                  console.log(response);
              },
              onError: function(error){
                  console.log(error);
              }
          }
      ); 
    },

    fn_pageLoadComplete: function(){
      this.getData('onPageLoadCompleted', null, 
      {
          onSuccess: function(response){
              console.log(response);
          },
          onError: function(error){
              console.log(error);
          }
      })
    },

    fn_openExternalPage: function(pageUrl){
      this.getData('OpenBrowser', pageUrl, {
        onSuccess: function(response){
            console.log(response);
        },
        onError: function(error){
            console.log(error);
        }
      });
    },

    fn_goBack: function(){
      if(this.$root.platform === 'ios'){
        this.fn_iosGoBack(); 
      }
      else{
        this.$route.name === 'HomePage' ? this.exitApp() : this.$router.go(-1);
      }
    },

    fn_iosGoBack: function(){
      if(this.$route.name === 'HomePage'){
        this.getData('ExitApp', null, 
        {
            onSuccess: function(response){
                console.log(response);
            },
            onError: function(error){
                console.log(error);
            }
        });
      }
      else{
        this.$router.go(-1)
      }
    },

    fn_reloadApp: function(){
      this.getData('ExitAppManually', null, 
      {
          onSuccess: function(response){
              console.log(response);
          },
          onError: function(error){
              console.log(error);
          }
      });
      
    },

    fn_downloadStatus: function(value, path){
      console.log(value, path);
      if(path){
        this.downloadStatus = null;
        this.fn_openInstallDialog(path);
      }
      else{
        this.downloadStatus = value;
      }
    },

    fn_openInstallDialog: function(path){
      this.getData('OpenInstallDialog', path, {
        onSuccess: function(response){
            console.log(response);
        },
        onError: function(error){
            console.log(error);
        }
      });
    },

    fn_getToken: function(callback){
      this.getData("FirebaseToken", null, 
          {
            onSuccess: function(response){
                console.log(response);
                callback ? callback(response) : '';
            },
            onError: function(error){
                console.log(error);
                callback('error');
            }
          }
      );
    },

    fn_getPersonalInfo: function(){
      // this.loading = true;
      // this.error = false;
      let self = this;

      this.fn_getToken(token=>{
          if(token == 'error'){
              this.loading = false;
              this.error = true;
              this.$root.fn_showToast('exception');
          }
          else{
              var headersObj = {
                  headers: { 
                      'Authorization': 'bearer '+token,
                  }
              };

              axios.get(self.baseUrl + '/api/mobileapp/admin/permissions/list', headersObj, {timeout:30000})
              .then(response => {
                  self.tripInfo =  response.data;
                  console.log(self.tripInfo);
                  // this.loading = false;
                  self.$forceUpdate();
              }).catch(e => {
                  // this.loading = false;
                  // this.error = true;
                  // let toastMsg = e && e.message ? e.message : 'exception';
                  // this.$root.fn_showToast(toastMsg);
                  console.log(e);
              })
          }
      })  
    },

    fn_showUpdate: function(url, newUrl){
        console.log(' Old URL : ' + url +' New URL : ' + newUrl)
        let currentVer = url;
        let newVer = newUrl;
        console.log("Show Update Called new url");
        if(currentVer && newVer && currentVer != newVer){
          this.$eventHub.$emit('updatefound');
        }
    },

    fn_checkDynamicPDF: function(filePath, filename){
        let self = this;
        self.PdfHeader = filename;
        console.log(self.PdfHeader);
        
        // let fileName = filePath.substring((filePath.lastIndexOf('/'))+1);
        console.log(filePath);
        this.getData('GetPDF', filename, {
          onSuccess: function(response){
              console.log(response);
              if(JSON.parse(response)){
                self.fn_openPDF(filename);
              }
              else{
                self.fn_downloadPDF(filePath, filename);
              }
          },
          onError: function(error){
              console.log(error);
          }
        });
    },

    fn_downloadPDF: function(filePath, filename){
        let self = this;
        let dataObj = {};
        dataObj.FileName = filename;
        dataObj.FileUrl = this.baseUrl + filePath;
        dataObj.DisplayName = dataObj.FileName;
        // this.downloading = true;
        console.log('downloading');
        this.loader = true;
        this.$eventHub.$emit('downloadingpdf', true);
        this.getServerData('DownloadFile', dataObj, {
            onSuccess: function(response){
                console.log(response);
                console.log('downloaded');
                self.loader = false;
                self.fn_openPDF(dataObj.FileName);
                self.$eventHub.$emit('downloadingpdf', false);
            }, 
            onError: function(error){
                console.log(error);
                self.loader = false;
                self.$root.fn_showToast('exception');
                self.$eventHub.$emit('downloadingpdf', false);
            }, 
        });
    },

    fn_openPDF: function(fileName){
      let filterObject = {};
      filterObject.PdfHeader = this.PdfHeader;
      console.log(filterObject.PdfHeader);
      this.getFilterData('OpenPDF', fileName, filterObject, {
          onSuccess: function(response){
            console.log(response);
          }, 
          onError: function(error){
            console.log(error);
          }
      });
    },

    fn_checkStoragePermission: function(callback){
      this.getData('CheckStoragePermission', 'StoragePermission', {
        onSuccess: function(response){
          console.log(response);
          callback ? callback(response) : '';
        },
        onError: function(error){
          console.log(error);
        }
      })
    },

  },
  mounted() {
    window.js_globals.fn_onBackPress = this.fn_goBack;
    window.js_globals.fn_setStatus = this.fn_downloadStatus;
    window.js_globals.fn_showUpdate = this.fn_showUpdate;
    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.iosMessageInterface) {
      this.platform = "ios"
    }
    /*global AndroidRoutingTest*/
    else if (typeof AndroidRoutingTest !== "undefined" && AndroidRoutingTest !== null) {
      this.platform = "android"
    }
    else {
      this.platform = "web"
    }
  },
}).$mount('#app')
